import React from 'react';
import { Route, Switch } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';
import Home from '../../home';
import UpdatesUserConfirmScreen from '../../updates/user-confirm/Screen';
import UpdatesUserUpdatesScreen from '../../updates/user-updates/Screen';
import UsersScreen from '../../user/users/Screen';
import LoginScreen from '../../auth/LoginScreen';
import ChangePassScreen from '../../auth/ChangePassScreen';
import InviteScreen from '../../invite/Screen';
import InviteAcceptScreen from '../../invite/accept/Screen';
import ProjectsScreen from '../../projects/Screen';
import NewslettersScreen from '../../newsletters/Screen';
import AdminInvitesScreen from '../../admin/invites/Screen';
import AdminSettingsScreen from '../../admin/settings/Screen.js';
import ProjectDetailsScreen from '../../projects/details/Screen';
import OnboardingProjectsScreen from '../../onboarding/add-projects/Screen.js';
import OnboardingSideProjectsScreen from '../../onboarding/add-side-projects/Screen.js';
import OnboardingGoalsScreen from '../../onboarding/add-goals/Screen.js';
import NotFoundScreen from '../../not-found/Screen.js';
import UserScreen from '../../user/Screen';
import Wrapper from '../../common/Wrapper';
import ScrollToTop from '../../common/ScrollToTop';
import CoreDataProvider from '../../workspace/CoreDataProvider';

const Routes = () => (
  <CoreDataProvider>
    <ScrollToTop>
      <Switch>
        <Route exact path="/invite/:inviteId" component={InviteScreen} />
        <Route
          exact
          path="/invite/:inviteId/accept"
          component={InviteAcceptScreen}
        />

        <PrivateRoute exact path="/" ifLoggedInShouldRedirectTo="/home" />

        <PrivateRoute
          exact
          path="/onboarding/add-projects"
          component={OnboardingProjectsScreen}
        />
        <PrivateRoute
          exact
          path="/onboarding/add-side-projects"
          component={OnboardingSideProjectsScreen}
        />
        <PrivateRoute
          exact
          path="/onboarding/add-goals"
          component={OnboardingGoalsScreen}
        />

        <Route exact path="/login" component={LoginScreen} />
        <Route exact path="/change-pass/:token" component={ChangePassScreen} />

        <PrivateRoute
          component={() => (
            <Wrapper>
              <Switch>
                <PrivateRoute exact path="/home" component={Home} />
                <PrivateRoute
                  exact
                  path="/updates/last"
                  component={UpdatesUserUpdatesScreen}
                />
                <PrivateRoute
                  exact
                  path="/updates/confirm"
                  component={UpdatesUserConfirmScreen}
                />
                <PrivateRoute exact path="/users" component={UsersScreen} />
                <PrivateRoute
                  exact
                  path="/users/:userId"
                  component={UserScreen}
                />
                <PrivateRoute exact path="/my-profile" component={UserScreen} />
                <PrivateRoute
                  exact
                  path="/projects"
                  component={ProjectsScreen}
                />
                <PrivateRoute
                  exact
                  path="/newsletters"
                  component={NewslettersScreen}
                />
                <PrivateRoute
                  exact
                  path="/admin/invites"
                  component={AdminInvitesScreen}
                />
                <PrivateRoute
                  exact
                  path="/admin/settings"
                  component={AdminSettingsScreen}
                />
                <PrivateRoute
                  exact
                  path="/projects/:projectId"
                  component={ProjectDetailsScreen}
                />
                <Route component={NotFoundScreen} />
              </Switch>
            </Wrapper>
          )}
        />

        <Route component={NotFoundScreen} />
      </Switch>
    </ScrollToTop>
  </CoreDataProvider>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/core/routing/index.js